import { useSelector } from 'react-redux';
import { Languages } from '../../utils/LanguageData';
import useLanguageChange from '../../utils/useLanguageChange';
import Translatable from '../translatable_text/Translatable';
import { AppState } from '@/store/Store';
import earthFlagBlack from '/src/assets/images/flag/icon-earth-b.svg';

export default function Language() {

  const customizer = useSelector((state: AppState) => state.customizer);
  const currentLang = Languages.find((lang) => lang.value === customizer.isLanguage) || Languages[0];
  const lang = Languages.filter((lang) => lang.value !== customizer.isLanguage)[0];
  const langChange = useLanguageChange();

  const handleChageLanguage = ( value: string ) => {
   langChange(value);
  };

  return (
    <div>
      <h2 className="sub-title mb-15 opacity-7"><Translatable>language</Translatable></h2>
      <div
        style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 2, cursor: "pointer" }}
        onClick={() => handleChageLanguage(lang.value)}
      >
        <img style={{ width: 20, height: 20 }} src={earthFlagBlack} alt="" />
        <span 
          style={{ color: currentLang.value !== lang.value ? "black" : 'lightgray', cursor: "pointer" }} 
          className='lang-text'
        >
          {lang.name}
        </span>
      </div>
    </div>
  )
}

